<template>
  <div class="DetailEquityCompare" v-if="isShow">
    <!--  绑定手机  -->
    <CgModalMiddle @close="isShow = false">
      <div slot="modal_content" class="modal_content">
        <div class="title">企业VIP授权范围对比</div>
        <div class="txt-compare" @click="toCompanyIntro">查看详细对比<i class="iconfont icon-a-arrowright"/></div>

        <div class="equity-list">
          <div class="equity-item">
            <div class="name">授权范围类目</div>
            <div class="list">
              <div class="list-item"
                   v-for="vo in TUPIAN_DETAIL.COMPANY_EQUITY_COMPARE.CATEGORY"
              >
                {{ vo }}
                <i class="iconfont icon-question" v-if="vo == '其他用途'">
                  <span class="dropbox">
                    <span class="dropbox-item">
                      {{ '敏感用途、商标logo、内置转售' }}
                    </span>
                  </span>
                </i>
              </div>
            </div>
          </div>
<!--         -->
          <div class="equity-item equity-item-version "
               :class="{ 'ON' : companyVipState == 1  && vo.type.indexOf(companyVipInfo.vip) > -1}"
               v-for="vo in TUPIAN_DETAIL.COMPANY_EQUITY_COMPARE.LIST"
               @click="toPay(vo)"
          >
            <div class="curr-vip" v-if="companyVipState == 1 && vo.type.indexOf(companyVipInfo.vip) > -1">
              <span>当前VIP</span>
            </div>
            <div class="name">{{ vo.label }}</div>
            <div class="list">
              <div class="list-item"
                   v-for="item in vo.list"
              >
                <i
                  :class="[ item == 1 ? 'iconfont icon-gou21' : 'iconfont3 icon-cz-close-circle-fill']"
                  class=""></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CgModalMiddle>
  </div>
</template>

<script>
import {TUPIAN_DETAIL} from "@/constant/tupian/TUPIAN_DETAIL";
import { mapState } from "vuex";
import {fnRouter} from "@/fn";
import { PAGE_PATH, PAGE_LINK } from '@/constant/PAGE_PATH'

export default {
  name: "DetailEquityCompare",
  computed: {
    ...mapState('user',
      [
        'personVipState',
        'personVipInfo',
        'businessVipState',
        'businessVipInfo',
        'companyVipState',
        'companyVipInfo',
        'isLogin',
        'downloadCount', 'companyInfoByPerson', 'uniq_id'
      ]
    ),
  },
  data() {
    return {
      isShow: false,
      TUPIAN_DETAIL
    }
  },
  methods:{
    toCompanyIntro(){
      let path = PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP;
      fnRouter.navigationTo(path)
    },

    toPay(vo){
      if (vo.label == '定制版'){
        fnRouter.navigationTo(PAGE_LINK.SERVICE)
      }else{
        let path = PAGE_PATH.BASE_URL+ PAGE_PATH.PAYMENT.DEFAULT + `/${vo.ID}`;
        console.log(path)
        fnRouter.navigationTo(path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.icon-gou21, .icon-cz-close-circle-fill {
  font-size: 14px;
}

.icon-gou21 {
  color: #35D0BA;
}

.icon-cz-close-circle-fill {
  color: #FF5E69;
}

.DetailEquityCompare {
  /deep/ .Modal{
    margin-top: 50px;
  }
  .modal_content {
    width: 668px;
    height: 576px;
    background: #FFFFFF;
    box-shadow: -4px 0px 12px 0px rgba(0, 0, 26, 0.06);
    border-radius: 14px;

    padding: 30px 34px 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 26px;
      font-size: 20px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 26px;
      letter-spacing: 2px;
      margin-bottom: 7px;
    }


    .txt-compare {
      font-size: 13px;
      color: rgba(0, 16, 19, 0.4);
      line-height: 18px;
      margin-bottom: 21px;

      .icon-a-arrowright {
        font-size: 14px;
      }

      @include ElementHover(rgba(0, 16, 19, 0.6))
    }


    .equity-list {
      display: flex;

      .equity-item {
        width: 150px;

        .name {
          height: 44px;
          background: #FFFFFF;
          line-height: 44px;
          padding-left: 22px;
          color: rgba(45, 43, 51, 1);
          font-size: 14px;
          font-weight: bold;
          color: #2D2B33;

        }

        .list {
          .list-item {
            height: 34px;
            line-height: 34px;

            &:nth-child(2n-1) {
              background: #FAFAFC;;
            }


            >i {
              position: relative;
              font-size: 14px;
              line-height: 30px;
              cursor: pointer;

              &:hover{
                .dropbox{
                  display: block !important;
                }
              }

              .dropbox {
                @include Position(1, 5, 50%, 18px);
                transform: translateX(-50%);
                z-index: 9;
                background: #424866;
                border-radius: 8px;
                display: none;


                &:after {
                  content: '';
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  background: #424866;
                  @include Position(1, 5, 50%, -3px);
                  transform: translateX(-50%) rotate(135deg);
                }

                .dropbox-item {
                  //width: 200px;
                  height: 20px;
                  line-height: 20px;
                  padding: 0px 8px;
                  color: #FFFFFF;
                  white-space: nowrap;
                  font-size: 12px;

                  &:last-child {
                    margin-bottom: 0;
                  }

                }
              }

            }

          }
        }


        &:first-child {
          .list {
            .list-item {
              padding-left: 22px;
              font-size: 12px;
              color: rgba(45, 43, 51, 0.85);
            }
          }
        }
      }

      .equity-item-version {
        width: 90px;

        &:hover {
          background: #F5F6FA;

          .name, .list-item {
            background: #F5F6FA !important;
          }
        }

        .name {
          text-align: center;
          padding-left: 0;
        }

        .list-item {
          text-align: center;
        }

        &.ON{
          background: rgba(255, 237, 217, 1);
          border-radius: 8px;
          //overflow: hidden;
          position: relative;

          .name, .list-item {
            background: rgba(255, 237, 217, 1) !important;
          }

          .list{
            border-radius: 0 0 8px 8px;
            overflow: hidden;
          }

          .curr-vip{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            @include Position(1,5,0,-9px);
            background: rgba(255, 237, 217, 1);
            border-radius: 10px;

            span{
              display: inline-block;
              width: 74px;
              height: 18px;
              background: #FFE1BB;
              border-radius: 0px 0px 10px 10px;
              text-align: center;
              font-size: 12px;
              color: #865742;
              line-height: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
